import { client } from './client'
import type { SkillAttachment } from '@/types'

export const skillAttachmentsApi = {
  getBySkill: (projectId: string, skillId: string) =>
    client.get<SkillAttachment[]>(`/projects/${projectId}/skills/${skillId}/attachments`).then(r => r.data),

  upload: (projectId: string, skillId: string, files: File[]) => {
    const formData = new FormData()
    files.forEach(file => formData.append('files', file))
    return client.post<{ attachmentIds: string[] }>(
      `/projects/${projectId}/skills/${skillId}/attachments/upload`,
      formData,
      { headers: { 'Content-Type': undefined } }
    ).then(r => r.data)
  },

  delete: (projectId: string, skillId: string, attachmentId: string) =>
    client.delete(`/projects/${projectId}/skills/${skillId}/attachments/${attachmentId}`),

  getDownloadUrl: (projectId: string, skillId: string, attachmentId: string) =>
    client.get<string>(
      `/projects/${projectId}/skills/${skillId}/attachments/${attachmentId}/download-url`
    ).then(r => r.data),
}
